import TopMenu from "./components/topmenu";
import Footer from "./components/footer";
import { Box } from '@mui/material';

function MainLayout({ children }) {
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
                <TopMenu />
                <Box sx={{ p: 2, flex: 1 }}>
                    {children}
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Footer />
            </Box>
        </>

    );
}

export default MainLayout;
